/**
 * @file 工具函数库
 * @author congpeisen@baidu.com
 */
// import {MAP_SK, MAP_AK} from './conf';
// import md5 from 'md5';
/* globals getApp, swan */
/**
 * 判断是否为对象
 * @param {*} val 待校验的值
 * @return {boolean}
 */
export let isObject = val => {
  return Object.prototype.toString.call(val) === '[object Object]';
};

/**
 * 扩展对象
 */
export function extend(...arr) {
  // let arr = Array.prototype.slice.call(arguments);
  let org = arr.shift();
  arr.forEach(function (obj) {
    let o = obj || {};
    Object.getOwnPropertyNames(o).forEach(function (key) {
      if (isObject(o[key]) && isObject(org[key])) {
        extend(org[key], o[key]);
      } else {
        if (o[key] !== undefined) {
          org[key] = o[key];
        }
      }
    });
  });
  return org;
}

/**
 * 判断是否为数组
 * @param {*} val 待校验的值
 * @return {boolean}
 */
export let isArray = val => {
  return Object.prototype.toString.call(val) === '[object Array]';
};
export let isEmptyObject = val => {
  return isObject(val) && Object.getOwnPropertyNames(val).length === 0;
};

/**
 * 获取url中的query，生成键值对
 *
 * @param {string} url 样本url
 * @return {Object} query键值对
 */
export let getQueryObject = url => {
  if (!url) {
    return {};
  }
  let search = url.substring(url.lastIndexOf('?') + 1);
  let obj = {};
  search.replace(/([^?&=#]+)=([^?&#]*)/g, function (rs, $1, $2) {
    obj[$1] = $2 || '';
    return rs;
  });
  return obj;
};
export let getUrlQuery = () => {
  let newQuery;
  {
    const url = window.location.href;
    let search = url.substring(url.lastIndexOf('?') + 1);
    let obj = {};
    search.replace(/([^?&=#]+)=([^?&#]*)/g, function (rs, $1, $2) {
      obj[$1] = $2 || '';
      return rs;
    });
    newQuery = obj;
  }
  return newQuery;
};
export let getQueryStr = obj => {
  if (isObject(obj)) {
    return Object.getOwnPropertyNames(obj).map(key => `${key}=${obj[key]}`).join('&');
  }
  return '';
};

/**
 * 获取某个对象/数组深层key对应的值（防止深层取值报错）
 *
 * @param {Object} obj 目标对象
 * @param {string} path 查询路径（如：对象 obj = {a:b:[{c:1},{c:2}]}，获取obj.a.b[1].c, path为'a.b.1.c'）
 * @return {any} 查询对象存在，则返回key对应的值；不存在则返回undefined
 */
export let getDataByPath = (obj, path) => {
  if (!path) {
    return obj;
  }
  if (!isObject(obj) && !isArray(obj)) {
    return;
  }
  let arr = path.split('.');
  let key = arr.shift();
  let val = obj[key];
  if (val === undefined) {
    return undefined;
  } else if (arr.length === 0) {
    return val;
  } else if (isObject(val) || isArray(val)) {
    return getDataByPath(val, arr.join('.'));
  }
};

/**
 * 去掉首尾空格
 * @param {string} str 目标字符串
 * @return {string} 去掉收尾空格后的字符串
*/
export let trim = str => {
  return str.replace(/(^\s*)|(\s*$)/g, '');
};

/**
 * 格式化日期
 * @param {number} timestamp 时间戳(ms)
 * @param {string} fmt 日期格式
 * @return {string} 格式化后的时间
 */
export let formatDate = (timestamp, fmt) => {
  const date = new Date(Number(timestamp));
  const o = {
    'M+': date.getMonth() + 1,
    // 月份
    'd+': date.getDate(),
    // 日
    'h+': date.getHours(),
    // 小时
    'm+': date.getMinutes(),
    // 分
    's+': date.getSeconds(),
    // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3),
    // 季度
    'S': date.getMilliseconds() // 毫秒
  };

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  return fmt;
};

/**
 * 下划线转驼峰式
 * @param {Object} obj 下划线对象
 * @return {Object} 返回驼峰式对象
 */
export function toHumpObj(obj) {
  let newObj = {};
  for (let i in obj) {
    if ({}.hasOwnProperty.call(obj, i)) {
      let key = i.replace(/\_(\w)/g, (all, letter) => {
        return letter.toUpperCase();
      });
      newObj[key] = obj[i];
    }
  }
  return newObj;
}

/**
 * 节流函数
 * @param {Function} fn 节流函数对象
 * @param {number} delay 节流阈值（两次触发间隔小于等于delay，则第二次不触发）
 * @return {Function} 返回执行函数
 */
export let throttle = (fn, delay) => {
  let start = 0;
  delay = delay || 300;
  return function (...args) {
    // 添加计时器，delay内的fn均不可执行
    let cur = new Date().getTime();
    if (cur - start > delay) {
      // 执行fn
      start = cur;
      return fn.apply(this, args);
    }
  };
};

/**
 * 防抖函数
 * @param {Function} fn 函数对象
 * @param {number} delay 延迟执行的时间，只执行最后一次
 */
export let debounce = (fn, delay) => {
  delay = delay || 300;
  let timer = null;
  return function (...args) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn.apply(this, args);
      timer = null;
    }, delay);
  };
};

/**
 * 生成n位随机数
 * @param {number} n 随机数位数
 * @return {string} 随机数
 */
export let rand = n => {
  n = n || 10;
  const regex = new RegExp('(\\d{' + n + '})(\\.|$)');
  return (Array(n - 1).join(0) + Math.pow(10, n) * Math.random()).match(regex)[1];
};
export function setStorage(key, data) {
  // TODO 存储满了需要清理
  getApp().$api.setStorageSync(key, data);
}
export function getStorage(key) {
  return getApp().$api.getStorageSync(key);
}
export function compareVersion(v1, v2) {
  let version1 = v1.split('.');
  let version2 = v2.split('.');
  let len = Math.max(v1.length, version2.length);
  while (version1.length < len) {
    version1.push('0');
  }
  while (version2.length < len) {
    version2.push('0');
  }
  for (let i = 0; i < len; i++) {
    let num1 = parseInt(version1[i], 10);
    let num2 = parseInt(version2[i], 10);
    if (num1 > num2) {
      return 1;
    } else if (num1 < num2) {
      return -1;
    }
  }
  return 0;
}
export function getApiInfo(url) {
  const map = [{
    str: 'lvlin.baidu.com/',
    group: 'rd_domainapi'
  }, {
    // cityList
    str: '8aQDcjqpAAV3otqbppnN2DJv',
    group: 'online_city'
  }, {
    // imgList
    str: '70cHazva2gU2pMbgoY3K/search/',
    group: 'online_img'
  }, {
    // imgPrice
    str: '9bMYfHSm2Q5IlBGlnYG/',
    group: 'online_img'
  }];
  const index = map.findIndex(obj => url.indexOf(obj.str) >= 0);
  if (index >= 0) {
    const suf = url.split(map[index].str)[1];
    const path = suf && suf.split('?') && suf.split('?')[0];
    return {
      path,
      group: map[index].group
    };
  }
  return null;
}
export function mapPageUrl(url = '') {
  // 页面路径转为页面名称方法，最后为index，直接取倒数第二项，最后不为index，取倒数第二项和最后一项得拼接
  const splitValue = url.split('/') || [];
  let pageName = '';
  if (splitValue && splitValue.length > 0) {
    if (splitValue[splitValue.length - 1] === 'index') {
      pageName = splitValue[splitValue.length - 2];
    } else {
      pageName = splitValue[splitValue.length - 2] + '/' + splitValue[splitValue.length - 1];
    }
  }
  return pageName;
}

// 计算两地距离-单位：km
export function getDistance(lat1, lng1, lat2, lng2) {
  let radLat1 = lat1 * Math.PI / 180.0;
  let radLat2 = lat2 * Math.PI / 180.0;
  let b = lng1 * Math.PI / 180.0 - lng2 * Math.PI / 180.0;
  let s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin((radLat1 - radLat2) / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
  s = s * 6378.137;
  s = (Math.round(s * 10000) / 10000).toFixed(1);
  return `${s}km`;
}

// 对象encodeURIComponent成字符串
export function httpBuildQuery(dataToSend = {}) {
  let formBody = [];
  for (let key in dataToSend) {
    if (dataToSend.hasOwnProperty(key)) {
      let encodedKey = encodeURIComponent(key);
      let encodedValue = encodeURIComponent(dataToSend[key]);
      formBody.push(encodedKey + '=' + encodedValue);
    }
  }
  return formBody.join('&');
}
// 地图api 计算sn
// export function caculateAKSN(url, queryObj) {
//     queryObj.output = 'json';
//     queryObj.ak = MAP_AK;
//     const callback = queryObj.callback;
//     if (callback) {
//         delete queryObj.callback;
//         queryObj.callback = callback;
//     }
//     const querystring = httpBuildQuery(queryObj);
//     // 定位使用
//     return md5(encodeURIComponent(`${url}?${querystring}${MAP_SK}`));
// }
/**
 * 同步获取设备信息
 *
 * @param {number} force 强制从接口获取
 * @return {swan.getSystemInfoSync.Return}
 */
export function getSystemInfoSync() {
  return {
    version: '1.7.48',
    setVersion: '1.7.49'
  };
}
/**
 * 预加载图片
 *
 * @param {Array} imgData 图片链接数组
 */

export function preloadImage(imgData) {
  {
    const images = [];
    for (let i = 0; i < imgData.length; i++) {
      images[i] = new Image();
      images[i].src = imgData[i];
    }
  }
}